import { c as _c } from "react/compiler-runtime";
import { ChevronLeft, ChevronRight, MoreHorizontal } from 'lucide-react';
import Link from 'next/link';
import * as React from 'react';
import { ButtonProps, buttonVariants } from '@/components/ui/button';
import { cn } from '@/lib/utils';
const Pagination = t0 => {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("mx-auto flex w-full justify-center", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <nav role="navigation" aria-label="pagination" className={t1} {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
Pagination.displayName = 'Pagination';
const PaginationContent = React.forwardRef<HTMLUListElement, React.ComponentProps<'ul'>>((t0, ref) => {
  const $ = _c(9);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("flex flex-row items-center gap-1", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== ref || $[7] !== t1) {
    t2 = <ul ref={ref} className={t1} {...props} />;
    $[5] = props;
    $[6] = ref;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
});
PaginationContent.displayName = 'PaginationContent';
const PaginationItem = React.forwardRef<HTMLLIElement, React.ComponentProps<'li'>>((t0, ref) => {
  const $ = _c(9);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== ref || $[7] !== t1) {
    t2 = <li ref={ref} className={t1} {...props} />;
    $[5] = props;
    $[6] = ref;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
});
PaginationItem.displayName = 'PaginationItem';
type PaginationLinkProps = {
  isActive?: boolean;
  hideText?: boolean;
  iconClassName?: string;
} & Pick<ButtonProps, 'size'> & React.ComponentProps<typeof Link>;
const PaginationLink = t0 => {
  const $ = _c(13);
  let className;
  let isActive;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      isActive,
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = isActive;
    $[3] = props;
    $[4] = t1;
  } else {
    className = $[1];
    isActive = $[2];
    props = $[3];
    t1 = $[4];
  }
  const size = t1 === undefined ? "icon" : t1;
  const t2 = isActive ? "page" : undefined;
  let t3;
  if ($[5] !== className || $[6] !== isActive || $[7] !== size) {
    t3 = cn(buttonVariants({
      variant: isActive ? "outline" : "ghost",
      size
    }), className);
    $[5] = className;
    $[6] = isActive;
    $[7] = size;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== props || $[10] !== t2 || $[11] !== t3) {
    t4 = <Link aria-current={t2} className={t3} {...props} />;
    $[9] = props;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
};
PaginationLink.displayName = 'PaginationLink';
const PaginationPrevious = t0 => {
  const $ = _c(18);
  let className;
  let iconClassName;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      hideText: t1,
      iconClassName,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = iconClassName;
    $[3] = props;
    $[4] = t1;
  } else {
    className = $[1];
    iconClassName = $[2];
    props = $[3];
    t1 = $[4];
  }
  const hideText = t1 === undefined ? false : t1;
  let t2;
  if ($[5] !== className) {
    t2 = cn("gap-1 pl-2.5", className);
    $[5] = className;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== iconClassName) {
    t3 = cn("h-4 w-4", iconClassName);
    $[7] = iconClassName;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t3) {
    t4 = <ChevronLeft className={t3} />;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== hideText) {
    t5 = !hideText && <span>Previous</span>;
    $[11] = hideText;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== props || $[14] !== t2 || $[15] !== t4 || $[16] !== t5) {
    t6 = <PaginationLink aria-label="Go to previous page" size="default" className={t2} {...props}>{t4}{t5}</PaginationLink>;
    $[13] = props;
    $[14] = t2;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
};
PaginationPrevious.displayName = 'PaginationPrevious';
const PaginationNext = t0 => {
  const $ = _c(18);
  let className;
  let iconClassName;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      hideText: t1,
      iconClassName,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = iconClassName;
    $[3] = props;
    $[4] = t1;
  } else {
    className = $[1];
    iconClassName = $[2];
    props = $[3];
    t1 = $[4];
  }
  const hideText = t1 === undefined ? false : t1;
  let t2;
  if ($[5] !== className) {
    t2 = cn("gap-1 pr-2.5", className);
    $[5] = className;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== hideText) {
    t3 = !hideText && <span>Next</span>;
    $[7] = hideText;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== iconClassName) {
    t4 = cn("h-4 w-4", iconClassName);
    $[9] = iconClassName;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t4) {
    t5 = <ChevronRight className={t4} />;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== props || $[14] !== t2 || $[15] !== t3 || $[16] !== t5) {
    t6 = <PaginationLink aria-label="Go to next page" size="default" className={t2} {...props}>{t3}{t5}</PaginationLink>;
    $[13] = props;
    $[14] = t2;
    $[15] = t3;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
};
PaginationNext.displayName = 'PaginationNext';
const PaginationEllipsis = t0 => {
  const $ = _c(10);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("flex h-9 w-9 items-center justify-center", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <MoreHorizontal className="h-4 w-4" />;
    t3 = <span className="sr-only">More pages</span>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  let t4;
  if ($[7] !== props || $[8] !== t1) {
    t4 = <span aria-hidden={true} className={t1} {...props}>{t2}{t3}</span>;
    $[7] = props;
    $[8] = t1;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
PaginationEllipsis.displayName = 'PaginationEllipsis';
export { Pagination, PaginationContent, PaginationEllipsis, PaginationItem, PaginationLink, PaginationNext, PaginationPrevious };